import { createAction } from 'redux-act';

export const isSignedUser = createAction('set is user sign', data => data);
export const callIsSignedUser = () => async (dispatch, getState) => {
  await dispatch(isSignedUser(getState().sign.signed_in));
};
